/**
 * Polyfill pour requestIdleCallback / cancelIdleCallback
 * 
 * Certaines versions de Safari (et WebViews iOS) ne supportent pas encore
 * l'API requestIdleCallback utilis�e par certaines librairies pour ex�cuter
 * des t�ches en p�riode d'inactivit� du navigateur.
 * 
 * Ce polyfill permet de simuler ce comportement via setTimeout afin d'�viter
 * les erreurs de type "ReferenceError: Can't find variable: requestIdleCallback".
 */
if (!('requestIdleCallback' in window)) {
  window.requestIdleCallback = function(cb, options) {
    var start = Date.now();
    return setTimeout(function() {
      cb({
        didTimeout: false,
        timeRemaining: function() {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, (options && options.timeout) || 1);
  };

  window.cancelIdleCallback = function(id) {
    clearTimeout(id);
  };
}

import React from "react";
import ReactDOM from "react-dom/client";
import NextApp from "./NextApp";
import { apiGeneralInterceptor } from 'util/api';

// Nettoyage de l'objet user d�ja enregistr� au pass� dans localStorage

try {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    delete user.created;
    delete user.ttl;
    delete user.userId;
    delete user.userRole;
    localStorage.setItem("user", JSON.stringify(user));
  }
} catch (e) {

}

apiGeneralInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));

const render = (Component) => {
  root.render(
    <Component />
  );
};

// Render initial
render(NextApp);

// HMR (optionnel)
if (module.hot) {
  module.hot.accept("./NextApp", () => {
    render(NextApp);
  });
}